import { CREATE_OR_UPDATE_QUOTE } from './createOrUpdateQuote';
import { GET_QUOTE_BY_VO_ID } from './getQuoteByVOId';
import { GET_QUOTE_BY_ID } from './getQuoteById';

export const quoteAPI = {
  getQuote: GET_QUOTE_BY_VO_ID,
  getQuoteById: GET_QUOTE_BY_ID,
  upsertQuote: CREATE_OR_UPDATE_QUOTE,
};
